














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

@Component
export default class EnumComponent extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: string;
  @Prop({ type: Object }) target!: any;
  @Prop({ type: String }) schema!: any;
  @Prop({ type: String }) placeholder!: string;

  enums: any[] = [];
  loaded: boolean = false

  localValue: any = null

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  updateValue(value: any) {
    this.onValueChange(value);

    this.$emit('input', value);
  }

  public loadData() {
    const QNAME = `SELECT_ENUM_COMBOBOX_LIST`;
    this.loaded = false;
    this.$db([
          this.$q(QNAME)
              .raw('schemas.get')
              .action({
                  id: `s:` + (this.target as any).table_name
              }),
      ]).then((result: ServerResult) => {
          const meta = fetchEnumsFromSchema(result.getOperation(QNAME).getContent().schema)
          this.enums = meta[(this.target as any).field_name].controlItems
          this.loaded = true;
      })
  }

  public mounted() {
    this.onValueChange(this.value);
    this.loadData()
  }
}
